import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import discardReportApi from '@custom/rtk-apis/report/discardReport';

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const discardReportSlice = createSlice({
  name: 'discardReportSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(discardReportApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(discardReportApi.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(discardReportApi.rejected, (state, {payload}) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default discardReportSlice.reducer;
